import Header from "../../Common/Header";
import DivindingEstate from "../../Components/DividingEstate";

const DividingEstatePage = () => {
  return (
        <>
          <Header />
          <DivindingEstate />
        </>
  );
};

export default DividingEstatePage;
